import { font, useLottie } from '@lemonade-hq/cdk';
import { COLORS } from '@lemonade-hq/tokens';
import type React from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import AnimationData from '../assets/diamond.json';

const Subtitle = styled.h3`
  display: flex;
  max-width: 95%;
  text-align: center;
  justify-content: flex-start;
  margin-top: 20px;
`;

const Diamond = styled.div`
  height: 40px;
  width: 40px;
  flex-shrink: 0;
`;
const SubtitleText = styled.span`
  ${font('main', { fontSize: '18px', lineHeight: '28px' })};
  color: ${COLORS.night};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 4px;
`;

const AnimatedDiamond: React.FC = () => {
  const animationRef = useRef<HTMLDivElement>(null);
  const lottieRef = useLottie(animationRef, {
    animationData: AnimationData,
    lottieConfig: {
      autoplay: false,
      loop: true,
    },
  });
  useEffect(() => {
    if (lottieRef) {
      lottieRef.play();
    }
  }, [lottieRef]);
  return <Diamond tabIndex={-1} aria-hidden="true" ref={animationRef} role="img" />;
};

interface ProductsSubtitleProps {
  readonly children: React.ReactNode;
  readonly showDiamond: boolean;
}

export const ProductsSubtitle: React.FC<ProductsSubtitleProps> = ({ children, showDiamond }) => {
  return (
    <Subtitle tabIndex={0}>
      {showDiamond && <AnimatedDiamond />}
      <SubtitleText>{children}</SubtitleText>
    </Subtitle>
  );
};
